import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Paper, Box, Typography, Divider } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { treeDeparts } from '../../modules/deptModule/departs';
import DeptTree from '../../components/deptmng/DeptTree';
import _ from 'lodash';

const HeadquarterListContainer = () => {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const [headquarters, setHeadquarters] = useState([]);

    const { departs, error, loading } = useSelector(
        ({ departModule, loading }) => ({
            departs: departModule.departs.departs,
            error: departModule.departs.error,
            loading: loading['depart/TREE_DEPART'],
        }),
    );

    const onHandleClick = (deptId) => {
        navigate(`/goalsetting/${deptId}`);
    }

    useEffect(() => {
        dispatch(treeDeparts({ "role_sales": 'SALES' }));
    }, [dispatch])

    useEffect(() => {
        if (departs) {
            let tempData = _.clone(departs);
            const hqData = tempData?.children.map((dept) => ({
                parent: dept.parent,
                level: dept.Level,
                id: dept.id,
                name: dept.name,
            }))
            tempData.children = hqData;
            setHeadquarters(tempData);
        }
    }, [departs])


    if (loading || !departs) {
        return null;
    }



    return (
        <Paper>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    backgroundColor: '#424242',
                    color: '#fff',
                    py: 1,


                }}
            >
                <Box sx={{ mx: 2 }}>
                    <AccountTreeIcon />
                </Box>
                <Typography variant="subtitle2" component="div">
                    조직도
                </Typography>
            </Box>
            <Divider />
            <DeptTree nodes={headquarters} onHandleClick={onHandleClick} />
        </Paper>
    )
}

export default HeadquarterListContainer